/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GoalYearInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class GoalYearApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'GoalYears');
  }

  find(params?: Record<string, any>): Observable<GoalYearInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<GoalYearInterface[]>(path, httpParams);
  }

  getGoalYearsForLearningArea(learningAreaId: number): Observable<GoalYearInterface[]> {
    const path = `${learningAreaId}/goal-years`;
    const params = undefined;
    return this.get<GoalYearInterface[]>(path, params);
  }
}
